import React, {useEffect, useState} from "react";
import {FlexColumnCentered} from "../../../../components/ui/Content";
import {ButtonDefault, ButtonPrimary} from "../../../../components/ui/Button";
import {Caption2, FormTitle} from "../../../../components/Font";
import {useTranslation} from "react-i18next";
import {InputAutoCompleteEnum, InputElement, InputTypeEnum} from "../../../../ui/Input/Input";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {
    ButtonContainer,
    RecoveryInputContainer,
    RegisterInputContainer
} from "../../../../components/ui/InputSearch";
import {useTheme} from "styled-components";
import {cleanError, setIsSecurityInputSend, SetNewPassword} from "../../Security/api/slice";
import {LoaderContainer, LoaderEnum, MiniLoader} from "../../../../ui/Loader/MiniLoader";

interface IChangePasswordFormProps {
    onClose: () => void
}

export const ChangePasswordForm = ({onClose}: IChangePasswordFormProps) => {

    const {t} = useTranslation();
    const dispatch = useAppDispatch()
    const Theme = useTheme()
    const {error, isSecurityInputSend, passwordChangePending} = useAppSelector(state => state.security)
    const [localPassword, setLocalPassword] = useState({old_password: '', password: '', password_repeat: ''})

    const isValid = localPassword.password === localPassword.password_repeat && localPassword.password.length >= 8 && localPassword.old_password.length > 0

    const handleSubmit = () => {
        if (isValid) {
            dispatch(SetNewPassword(localPassword))
        }
    }

    useEffect(() => {
        if (isSecurityInputSend) {
            onClose()
            dispatch(setIsSecurityInputSend())
        }
    }, [isSecurityInputSend])

    return <>
        <FlexColumnCentered style={{width: '100%', marginTop: '10px'}}>
            <FormTitle>Изменение пароля</FormTitle>
        </FlexColumnCentered>
        <RegisterInputContainer style={{marginTop: 28}}>
            <RecoveryInputContainer>
                <InputElement
                    autofocus={true}
                    placeholder='Введите текущий пароль'
                    error={error['old_password']}
                    type={InputTypeEnum.Password}
                    value={localPassword.old_password}
                    onChange={value => {
                        setLocalPassword({...localPassword, old_password: value})
                        if (error['old_password']) {
                            dispatch(cleanError('old_password'))
                        }
                    }}
                    onKeyDown={(key) => {
                        if (key === 'Enter') handleSubmit()
                    }}
                    autoComplete={InputAutoCompleteEnum.CurrentPassword}
                />
            </RecoveryInputContainer>
        </RegisterInputContainer>
        <Caption2 color={Theme.color.secondary} error={error['password']}
                  style={{width: '100%', paddingLeft: '16px', marginTop: '-4px'}}>
            {t('auth.passwordRules')}
        </Caption2>
        <RegisterInputContainer>
            <RecoveryInputContainer>
                <InputElement
                    placeholder='Придумайте пароль'
                    error={error['password']}
                    type={InputTypeEnum.Password}
                    value={localPassword.password}
                    onChange={value => {
                        setLocalPassword({...localPassword, password: value})
                        if (error['password']) {
                            dispatch(cleanError('password'))
                            dispatch(cleanError('password_repeat'))
                        }
                    }}
                    onKeyDown={(key) => {
                        if (key === 'Enter') handleSubmit()
                    }}
                    autoComplete={InputAutoCompleteEnum.NewPassword}
                />
            </RecoveryInputContainer>
        </RegisterInputContainer>
        <RegisterInputContainer>
            <RecoveryInputContainer>
                <InputElement
                    placeholder={t('auth.repeatPassword')}
                    type={InputTypeEnum.Password}
                    error={error['password_repeat']}
                    value={localPassword.password_repeat}
                    onChange={value => {
                        setLocalPassword({...localPassword, password_repeat: value})
                        if (error['password_repeat']) {
                            dispatch(cleanError('password'))
                            dispatch(cleanError('password_repeat'))
                        }
                    }}
                    onKeyDown={(key) => {
                        if (key === 'Enter') handleSubmit()
                    }}
                    autoComplete={InputAutoCompleteEnum.NewPassword}
                />
            </RecoveryInputContainer>
        </RegisterInputContainer>
        <ButtonContainer style={{marginTop: '34px'}}>
            <ButtonDefault style={{width: '165px'}} onClick={onClose}>Отмена</ButtonDefault>
            {passwordChangePending
                ? <ButtonPrimary style={{width: '165px', marginLeft: '20px'}} disabled={true}>
                    <LoaderContainer>
                        <MiniLoader color={Theme.color.primaryBackground} size={LoaderEnum.small}/>
                    </LoaderContainer>
                </ButtonPrimary>
                : <ButtonPrimary
                    disabled={!isValid}
                    onClick={handleSubmit}
                    style={{width: '165px', marginLeft: '20px'}}>
                    Сохранить
                </ButtonPrimary>}
        </ButtonContainer>
    </>
}
